import { get, writable } from 'svelte/store';
import { edit, initialEdit } from 'src/stores/ui/edit_lists';
import { is_mobile } from 'src/stores/ui/viewport';
import { prefersReducedMotion } from 'src/helpers/ui_transitions';

/** True while the Exit-edit control is dissolving before tabs restore. */
export const editChromeExitDissolving = writable(false);

/** Matches Tabs `.is-exit-dissolving` opacity/transform duration. */
export const EDIT_EXIT_DISSOLVE_MS = 200;

let exitInflight: Promise<void> | null = null;

/**
 * Leave list/dashboard edit mode. On mobile, dissolves the Exit / Finish
 * control first, then clears `$edit` so the tab rail can flow back down.
 * Also clears `initialEdit` (room-devices reorder path).
 */
export function requestExitEditMode(): Promise<void> {
	if (exitInflight) return exitInflight;

	exitInflight = (async () => {
		try {
			if (!get(edit)) {
				initialEdit.set(false);
				return;
			}

			const animateChrome = get(is_mobile) && !prefersReducedMotion();
			if (animateChrome) {
				editChromeExitDissolving.set(true);
				await new Promise<void>((resolve) => {
					setTimeout(resolve, EDIT_EXIT_DISSOLVE_MS);
				});
			}

			edit.set(false);
			initialEdit.set(false);
		} finally {
			editChromeExitDissolving.set(false);
			exitInflight = null;
		}
	})();

	return exitInflight;
}
